// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"4c9bd8d7","192":"55305f53","239":"eab0352a","326":"362fff0d","381":"417cafd3","438":"74c80a3a","540":"668cb1ba","732":"9ad56c4c","977":"3becd578"}[chunkId] + ".chunk.js";
};